import { Icon } from "@bridgesplit/ui";
import { Icons, NotificationTypeStyles } from "@dialectlabs/react-ui";

export const DIALECT_DAPP_ADDRESS = "L1T3Met3JG3EieFx8TTEiFE75ZL3huBdPTQ9CeaA7cK";

// Human Readable IDs: minorupdates, productupdates, liquidationwatch, liquidationwarning, lendvaultchanges, liquidationalert

NotificationTypeStyles["liquidationwatch"] = {
    Icon: <Icon type="pending" sx={{ width: 12, height: 12 }} />,
    iconColor: "#FFFFFF",
    iconBackgroundColor: "#FFD740",
    iconBackgroundBackdropColor: "#FFD7401A",
    linkColor: "#FFC400",
    actionGradientStartColor: "#FFD7401A"
};

NotificationTypeStyles["productupdates"] = {
    Icon: <Icon type="logo-icon" sx={{ width: 12, height: 12 }} />,
    iconColor: "#FFFFFF",
    iconBackgroundColor: "#256ed7",
    iconBackgroundBackdropColor: "#256ed71A",
    linkColor: "#1E88E5",
    actionGradientStartColor: "#256ed71A"
};

NotificationTypeStyles["minorupdates"] = {
    Icon: <Icon type="website" sx={{ width: 12, height: 12 }} />,
    iconColor: "#FFFFFF",
    iconBackgroundColor: "#4d8ff0",
    iconBackgroundBackdropColor: "#4d8ff01A",
    linkColor: "#1E88E5",
    actionGradientStartColor: "#4d8ff01A"
};

NotificationTypeStyles["lendvaultchanges"] = {
    Icon: <Icons.BellButtonOutline width={12} height={12} />,
    iconColor: "#FFFFFF",
    iconBackgroundColor: "#193a53",
    iconBackgroundBackdropColor: "#193a531A",
    linkColor: "#193a53",
    actionGradientStartColor: "#193a531A"
};

NotificationTypeStyles["liquidationalert"] = {
    Icon: <Icons.Bell width={12} height={12} />,
    iconColor: "#FFFFFF",
    iconBackgroundColor: "#FF0000",
    iconBackgroundBackdropColor: "#FF00001A",
    linkColor: "#FF0000",
    actionGradientStartColor: "#FF00001A"
};
